import * as types from "../actions/types";



const initialState = {
  list: null,
  loading: false,
  adsById: null
};


export default function documents_journal(state = initialState, action) {
  switch (action.type) {
    case types.SET_DOCUMENT_JOURNAL_LIST:
      return {
        ...state,
        docList: action.payload
      };
    case types.SET_DOCUMENT_JOURNAL_BY_ID:
      return {
        ...state,
        docById: action.payload
      };
    case types.SET_DOCUMENT_JOURNAL_LOADING:
      return {
        ...state,
        loading: action.payload
      };

    default:
      return state;
  }
}